/* export all the actions that modify the state
  examples:
*/

// FEATURED PAGE ACTIONS
export const GET_DISHTYPES = 'GET_DISHTYPES';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const TOGGLE_RDP_MODAL = 'TOGGLE_RDP_MODAL';

// GROCERIES FILTERS
export const TOGGLE_SKU_FILTER = 'TOGGLE_SKU_FILTER';
export const CLEAR_SKU_FILTERS = 'CLEAR_SKU_FILTERS';
export const APPLY_SKU_FILTERS = 'APPLY_SKU_FILTERS';
export const SELECT_SKU_CATEGORY = 'SELECT_SKU_CATEGORY';
export const GET_FILTERED_SKUS = 'GET_FILTERED_SKUS';
export const GET_DIETARY_PREFERENCES = 'GET_DIETARY_PREFERENCES';
export const CHANGE_SORTING = 'CHANGE_SORTING';

// RECIPES FILTERS
export const TOGGLE_RECIPE_FILTER = 'TOGGLE_RECIPE_FILTER';
export const CLEAR_RECIPE_FILTERS = 'CLEAR_RECIPE_FILTERS';
export const APPLY_RECIPE_FILTERS = 'APPLY_RECIPE_FILTERS';
export const OPEN_FILTER_MENU = 'OPEN_FILTER_MENU';
export const CLOSE_FILTER_MENU = 'CLOSE_FILTER_MENU';
export const SELECT_RECIPE_DISHTYPE = 'SELECT_RECIPE_DISHTYPE';
export const GET_FILTERED_RECIPES = 'GET_FILTERED_RECIPES';

// RECIPES/ GROCERIES FILTERS
export const GET_TAGS = 'GET_TAGS';

// SEARCH
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';

// MODAL ACTIONS
export const TOGGLE_CANCEL_MODAL = 'TOGGLE_CANCEL_MODAL';
export const OPEN_VOLUME_MODAL = 'OPEN_VOLUME_MODAL';
export const CLOSE_VOLUME_MODAL = 'CLOSE_VOLUME_MODAL';
export const TOGGLE_CLEAR_MODAL = 'TOGGLE_CLEAR_MODAL';
export const TOGGLE_EXP98_SAVE_BUTTON_MODAL = 'TOGGLE_EXP98_SAVE_BUTTON_MODAL';
export const TOGGLE_SAVE_THRESHOLD_MODAL = 'TOGGLE_SAVE_THRESHOLD_MODAL';
export const TOGGLE_EXP98_SAVE_THRESHOLD_MODAL =
  'TOGGLE_EXP98_SAVE_THRESHOLD_MODAL';
export const TOGGLE_CUTOFF_MODAL = 'TOGGLE_CUTOFF_MODAL';
export const OPEN_COLD_VOLUME_MODAL = 'OPEN_COLD_VOLUME_MODAL';
export const CLOSE_COLD_VOLUME_MODAL = 'CLOSE_COLD_VOLUME_MODAL';
export const TOGGLE_ERROR_MODAL = 'TOGGLE_ERROR_MODAL';

// Segment
export const CANCEL_EDITS_SEGMENT_TRK = 'CANCEL_EDITS_SEGMENT_TRK';
